<template>
  <div class="chart-container">
    <apexchart type="bar" :height="chartHeight" width="100%" :options="chartOptions" :series="series"/>
  </div>
</template>

<script>
export default {
  name: 'HeadcountFunctionChart',
  props: {
    chartSeries: {
      type: Array,
      required: true
    },
    chartHeight: {
      type: [Number, String],
      default: 400
    },
    companyPrimaryColor: {
      type: String,
      default: '#006859'
    }
  },
  computed: {
    sortedData() {
      const known = this.chartSeries.filter(d => d.disc_type !== 'Unknown')
      const unknown = this.chartSeries.filter(d => d.disc_type === 'Unknown')
      return [...known.sort((a, b) => b.headcount - a.headcount), ...unknown]
    },
    series() {
      return [{
        name: 'Headcount',
        data: this.sortedData.map(l => l.headcount)
      }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'Manrope, Arial, sans-serif'
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },       
        xaxis: {
          categories: this.sortedData.map(d => d.disc_type)
        },
        colors: [this.companyPrimaryColor],
        dataLabels: {
          enabled: true
        },
        tooltip: {
          y: { formatter: val => `${val} employees` }
        },
        legend: { show: false }
      }
    }
  }
}
</script>